import { memo } from 'react'
import CurieAvatar from '~/assets/curie-avatar.png'
import { InitialsAvatar } from '~/components/common/InitialsAvatar'
import { DocMarkdown } from '~/components/documents'
import { isTaskCommand, UsedCommandType } from '~/constants/commands'
import { useConversationMetadata } from '~/hooks'
import { cm } from '~/utils/utils'
import { CampaignBlock } from './campaignBlocks/CampaignBlock'

export interface CampaignMessageProps {
  message: Message
  inlineChat?: boolean
}

function CampaignChatMessage({ message, inlineChat }: CampaignMessageProps) {
  const className = 'px-6 py-2 text-black max-w-[90%] overflow-y-auto rounded-lg min-w-full'
  const isUser = message.role === 'user'
  const { command } = useConversationMetadata()

  const renderMessage = (message: Message) => {
    if (message.blocks) {
      const messageType = message.blocks[0].type
      let text = ''

      if (messageType === 'pr') text += 'Done! Please check the PR: '
      if (messageType === 'image') text += 'Done! Please check the image below:\n'

      return message.blocks.map((block, index) => (
        <CampaignBlock
          key={block.id || index}
          index={index}
          block={block}
          totalBlock={message.blocks?.length}
        />
      ))
    }

    return <DocMarkdown text={message.text || ''} />
  }

  if (!inlineChat && isTaskCommand(command as UsedCommandType)) {
    if (message.role == 'user') {
      return null
    }
    return renderMessage(message)
  }

  return (
    <div data-testid='message' className={cm('max-w-[100%]', className)}>
      <div className='user flex items-center mt-1'>
        {isUser ? (
          message.user_name ? (
            <>
              <InitialsAvatar name={message.user_name} size='sm' />
              <div className='ml-2 font-semibold dark:text-white'>{message.user_name}</div>
            </>
          ) : null
        ) : (
          <>
            <img
              src={CurieAvatar}
              alt={message.role}
              className='w-8 h-8 rounded-full select-none'
            />
            <div className='ml-2 font-semibold dark:text-white'>Curie</div>
          </>
        )}
      </div>
      {renderMessage(message)}
    </div>
  )
}

export default memo(
  CampaignChatMessage,
  (prev, next) => JSON.stringify(prev.message) === JSON.stringify(next.message)
)
